import React from "react";

import Heading from "core/Heading";
import DeniedGrid from "./DeniedGrid";

const SubmissionsDenied = () => {
    const hasDeniedSubmissions = true;

    if (!hasDeniedSubmissions) {
        return <Heading size="md">No photos have been denied.</Heading>;
    }

    return (
        <div data-testid="submissions-denied">
            <DeniedGrid />
        </div>
    );
};

export default SubmissionsDenied;
